import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { changeLanguage } from '../../../actions/language';
import { Conditional } from '../../../utils/consts/index';
import { checkMobileDevice } from '../../../utils/utility/index';
import { CheckCircleIcon, WarningIcon, CloseIcon, InfoCircleIcon } from '~svg';
import './confirmation.scss';
const CustomConfirmation = ({
  show,
  title,
  defaultDescription,
  onSubmit,
  onReject,
  languageName,
  isLocalization,
  showHeader = true,
  iconName = '',
}) => {
  return (
    <div className="col-lg-3 col-md-4 col-sm-6 col-8 d-flex flex-column justify-content-start align-items-center parentDiv">
      {showHeader ? (
        <div className="col px-2 py-3 border-2 border-bottom d-flex flex-row">
          <div
            className="col-11 p-0 d-flex align-items-center font-weight-bold"
            style={{ color: '#a5a5a5', fontSize: 'larger' }}
          >
            <FormattedMessage id="confirmation.confirmTitle" />
          </div>
          <div className="col-1 d-flex p-0 justify-content-end">
            <div
              id="closeButton"
              className=" cursor-pointer"
              onClick={onReject}
            >
              <CloseIcon size={22} color="#ccccccbd" />
            </div>
          </div>
        </div>
      ) : null}
      <div
        className={`col d-flex flex-column px-0  ${
          !checkMobileDevice() && 'py-4'
        } border-2 border-bottom`}
      >
        <div className="col d-flex flex-column py-2">
          {iconName && (
            <i
              className={`${iconName} text-secondary   ${
                checkMobileDevice() ? 'font-xlarge ' : 'font-huge'
              }  d-flex justify-content-center w-100 py-3`}
            ></i>
          )}
          <span className="font-weight-bold font-large">
            <span
              className="font-weight-bold font-lg-large font-sm-msmall font-normal d-flex justify-content-center"
              style={{ color: '#517799', textAlign: 'center' }}
            >
              <FormattedMessage id={title} />
            </span>
          </span>
        </div>
        <div className="col py-2 text-center">
          <span
            className="font-weight-bold font-lg-normal font-sm-smaller font-msmall"
            style={{ color: '#a3a3a38a' }}
          >
            {isLocalization ? (
              <FormattedMessage id={defaultDescription} />
            ) : (
              defaultDescription
            )}
          </span>
        </div>
      </div>
      <div className="col d-flex flex-row px-0 py-3 justify-content-center">
        <button
          name="reject-confirmation"
          id="reject-confirmation"
          type="button"
          className="col bg-white border-0 font-weight-bold"
          onClick={onReject}
          style={{
            color: '#dc2633',
          }}
        >
          <FormattedMessage id="confirmation.reject" />
        </button>
        <button
          name="submit-confirmation"
          id="submit-confirmation"
          type="button"
          className="bg-white border-0 col font-weight-bold"
          onClick={onSubmit}
          style={{
            color: '#28a745',
          }}
        >
          <FormattedMessage id="confirmation.confirm" />
        </button>
      </div>
    </div>
  );
};

const CustomAlert = ({
  show,
  onReject,
  body,
  closeTime,
  type,
  languageName,
  noHeight = false,
  showTitle = true,
}) => {
  const objOfIcon = {
    checkCircleIcon: <CheckCircleIcon color="#28a745" size={34} />,
    warningIcon: <WarningIcon color="#ffc107" size={34} />,
    closeIcon: <CloseIcon color="#dc2633" size={34} />,
    infoCircleIcon: <InfoCircleIcon color="#6f42c1" size={34} />,
  };
  const typeOfAlert = {
    iconName: objOfIcon.checkCircleIcon,
    label: 'alert.success',
    zIndex: 100000,
    boxShadow: 'rgba(40, 167, 69, 0.64) 1px 0px 6px',
  };

  if (type === 'warning') {
    typeOfAlert.iconName = objOfIcon.warningIcon;
    typeOfAlert.label = showTitle ? 'alert.warning' : 'alert.notitle';
    typeOfAlert.boxShadow = 'rgba(255, 193, 7, 0.64) 1px 0px 6px';
  } else if (type === 'error') {
    typeOfAlert.iconName = objOfIcon.closeIcon;
    typeOfAlert.label = showTitle ? 'alert.error' : 'alert.notitle';
    typeOfAlert.boxShadow = 'rgba(220, 38, 51, 0.64) 1px 0px 6px';
  } else if (type === 'info') {
    typeOfAlert.iconName = objOfIcon.infoCircleIcon;
    typeOfAlert.label = showTitle ? 'alert.info' : 'alert.notitle';
    typeOfAlert.boxShadow = 'rgba(111, 66, 193, 0.64) 1px 0px 6px';
  }
  const styles = {
    parentDiv: {
      position: 'absolute',
      top: '200px',
      height: noHeight ? '' : '110px',
      background: 'white',
      zIndex: 100000,
      boxShadow: `${typeOfAlert.boxShadow}`,
      borderLeft: languageName === 'en' && `4px solid ${typeOfAlert.color}`,
      borderRight: languageName === 'fa' && `4px solid ${typeOfAlert.color}`,
      borderRadius: '3px',
    },
  };
  return (
    <div
      className={`${
        checkMobileDevice() ? 'col-11' : ' col-5'
      } d-flex justify-content-start align-items-center`}
      style={styles.parentDiv}
    >
      <div className={`col-1  ${checkMobileDevice() && 'px-0'}`}>
        {typeOfAlert.iconName}
      </div>
      <div className="col-10 d-flex flex-column pt-2">
        <div className="col d-flex">
          <span className="font-weight-bold font-large">
            <FormattedMessage id={typeOfAlert.label} />
          </span>
        </div>
        <div className="col d-flex ">
          <span
            className={`font-weight-bold text-start font-smaller`}
            style={{ color: '#a3a3a3' }}
          >
            {body}
          </span>
        </div>
      </div>
      <div className="col-1 d-flex flex-row justify-content-end">
        <div id="closeButton" className=" cursor-pointer" onClick={onReject}>
          <CloseIcon size={16} color="#ccccccbd" />
        </div>
      </div>
    </div>
  );
};
function Confirmation({
  isConfirmation,
  show,
  onReject,
  onSubmit,
  title,
  body,
  closeTime,
  type,
  defaultDescription,
  language,
  isLocalization,
  noHeight,
  showTitle = true,
  showHeader = true,
  iconName = '',
}) {
  return (
    show && (
      <div
        className="position-fixed w-100 h-100 d-flex justify-content-center align-items-center"
        style={{
          top: 0,
          left: 0,
          backgroundColor: 'rgba(128,128,128,0.5)',
          zIndex: 5000,
        }}
      >
        <Conditional checkRender={isConfirmation === true}>
          <CustomConfirmation
            show={true}
            iconName={iconName}
            onReject={onReject}
            onSubmit={onSubmit}
            title={title}
            body={body}
            defaultDescription={defaultDescription}
            languageName={language.name}
            isLocalization={isLocalization}
            showHeader={showHeader}
          />
        </Conditional>
        <Conditional checkRender={isConfirmation === false}>
          <CustomAlert
            noHeight={noHeight}
            showTitle={showTitle}
            show={true}
            closeTime={closeTime}
            onReject={onReject}
            title={title}
            body={body}
            type={type}
            languageName={language.name}
          />
        </Conditional>
      </div>
    )
  );
}
function mapStateToProps(state, props) {
  return {
    language: state.language,
  };
}

Confirmation.defaultProps = {
  show: false,
  title: 'success',
  body: 'this is test',
  defaultDescription:
    'Press OK to continue , or Cancel to stay on the current page',
  closeTime: 2,
  isLocalization: true,
  iconName: '',
  showHeader: true,
};
Conditional.propTypes = {
  children: PropTypes.element.isRequired,
};
// Confirmation.propTypes = {
//   show: PropTypes.bool.isRequired,
//   title: PropTypes.string,
//   body: PropTypes.string.isRequired,
//   defaultDescription: PropTypes.string,
//   onReject: PropTypes.func.isRequired,
//   onSubmit: PropTypes.func.isRequired
// };
export default connect(mapStateToProps, { changeLanguage })(Confirmation);
